import type { USP } from "@/routes/innovation-days-demo/types";

interface USPContentProps {
  usps: USP[];
}

export function USPContent({ usps }: USPContentProps) {
  return (
    <div className="space-y-4">
      {usps.map((u) => (
        <div key={u.title} className="relative pl-4">
          {/* Left accent bar */}
          <div
            className="absolute left-0 top-0 bottom-0 w-1 rounded-full"
            style={{ background: "#6366F1" }}
          />

          <div className="space-y-1.5">
            {/* USP title */}
            <h4
              className="text-[15px] leading-[20px] font-semibold"
              style={{ color: "#0F172A" }}
            >
              {u.title}
            </h4>

            {/* USP description */}
            <p
              className="text-[14px] leading-[20px]"
              style={{ color: "#64748B" }}
            >
              {u.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
